const STYLE_VERTEX_UNIFORMS = "uniform float focalAdjustment;\nuniform int styleMode;\nuniform float stylePointSize;";
const STYLE_VERTEX_SCALE_BLOCK = `float scale1 = min(maxPixelRadius, adjustedStdDev * sqrt(eigen1));
    float scale2 = min(maxPixelRadius, adjustedStdDev * sqrt(eigen2));`;
const STYLE_VERTEX_SCALE_PATCH = `float scale1 = min(maxPixelRadius, adjustedStdDev * sqrt(eigen1));
    float scale2 = min(maxPixelRadius, adjustedStdDev * sqrt(eigen2));
    if (styleMode == 1) {
        float pointScale = max(minPixelRadius, stylePointSize);
        scale1 = pointScale;
        scale2 = pointScale;
    }`;

const STYLE_FRAGMENT_UNIFORMS = "uniform float falloff;\nuniform int styleMode;\nuniform float styleRingSize;";
const STYLE_FRAGMENT_ALPHA_BLOCK = "if (rgba.a < minAlpha) {";
const STYLE_FRAGMENT_ALPHA_PATCH = `float sparkA = z2 / max(1e-6, adjustedStdDev * adjustedStdDev);
    if (styleMode == 2 && styleRingSize > 0.0) {
        float inner = max(0.0, 1.0 - styleRingSize);
        if (sparkA < inner) {
            rgba.a = max(0.05, rgba.a);
        } else {
            rgba.a = 0.6;
        }
    }

    if (rgba.a < minAlpha) {`;

export const SPARK_STYLE_PROGRAM_CACHE_KEY = "spark-style-mode-v2";

export function applySparkStyleShaderPatch(shader, pointModeSize) {
  if (!shader.uniforms.styleMode) {
    shader.uniforms.styleMode = { value: 0 };
  }
  if (!shader.uniforms.styleRingSize) {
    shader.uniforms.styleRingSize = { value: 0.0 };
  }
  if (!shader.uniforms.stylePointSize) {
    shader.uniforms.stylePointSize = { value: pointModeSize };
  }

  shader.vertexShader = shader.vertexShader
    .replace("uniform float focalAdjustment;", STYLE_VERTEX_UNIFORMS)
    .replace(STYLE_VERTEX_SCALE_BLOCK, STYLE_VERTEX_SCALE_PATCH);

  shader.fragmentShader = shader.fragmentShader
    .replace("uniform float falloff;", STYLE_FRAGMENT_UNIFORMS)
    .replace(STYLE_FRAGMENT_ALPHA_BLOCK, STYLE_FRAGMENT_ALPHA_PATCH);
}
